export interface WeekRange {
	monday: Date;
	friday: Date;
}

export function getWeekRange(dateStr: string): WeekRange | null {
	if (!dateStr) {
		return null;
	}

	const date = new Date(dateStr);
	if (isNaN(date.getTime())) {
		return null;
	}

	const day = date.getDay();
	const diffToMonday = day === 0 ? -6 : 1 - day;
	const monday = new Date(date);
	monday.setDate(date.getDate() + diffToMonday);
	monday.setHours(0, 0, 0, 0);

	const friday = new Date(monday);
	friday.setDate(monday.getDate() + 4);
	friday.setHours(23, 59, 59, 999);

	return { monday, friday };
}

export function formatWeekRange(range: WeekRange): string {
	if (!range) {
		return '';
	}

	const pad = (n: number) => n.toString().padStart(2, '0');
	const mon = `${pad(range.monday.getDate())}/${pad(range.monday.getMonth() + 1)}`;
	const fri = `${pad(range.friday.getDate())}/${pad(range.friday.getMonth() + 1)}`;
	return `${mon} - ${fri}`;
}

export function getAggregateWeekRange(dates: string[]): WeekRange | null {
	const ranges = dates
		.map((d) => getWeekRange(d))
		.filter((r): r is WeekRange => r !== null);

	if (ranges.length === 0) {
		return null;
	}

	const earliestMonday = new Date(Math.min(...ranges.map((r) => r.monday.getTime())));
	const latestFriday = new Date(Math.max(...ranges.map((r) => r.friday.getTime())));

	return { monday: earliestMonday, friday: latestFriday };
}
